import React, { useEffect, useState, useRef } from "react";
import { useSwipeable } from "react-swipeable";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

import BirthDefectsControl from "../assets/BirthDefectsControl.webp";
import DamClientmeet from "../assets/Dam_Client_meet.webp";
import VegetraianClubMeet from "../assets/VegetraianClubMeet.webp";
import Niift from "../assets/Niift.webp";
import ScrollToHomeButton from "./ScrollToHomeButton";

const Contributions = () => {
  const contributions = [
    {
      image: BirthDefectsControl,
      info: "Honoured to support Nobel-worthy work — we created impactful video and graphic content for “Prabhu Public Health Professional” Research Papers for WHO, CDC & UNICEF.",
    },
    {
      image: DamClientmeet,
      info: "Bringing engineering to life — 3D visualization of a dam project for our esteemed client.",
    },
    {
      image: VegetraianClubMeet,
      info: "Honored to support Vegetarian Club, Hyderabad, with our creative services.",
    },
    {
      image: Niift,
      info: "Trusted by the National Institute of Fashion Technology (NIFT), Hyderabad - Haptic Realities delivers 3D Blender advanced skill workshops that empower students with real-world experience.",
    },
  ];

  const extendedContributions = [
    contributions[contributions.length - 1], // clone last
    ...contributions,
    contributions[0], // clone first
  ];

  const [currentIndex, setCurrentIndex] = useState(1); // start at real first image
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [autoPlay] = useState(true);

  const transitionRef = useRef();
  const containerRef = useRef(null);

  useEffect(() => {
    transitionRef.current = goToNext;
  });

  useEffect(() => {
    if (!autoPlay) return;
    const play = () => transitionRef.current();
    const interval = setInterval(play, 5000);
    return () => clearInterval(interval);
  }, [autoPlay]);

  const goToNext = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentIndex((prev) => prev + 1);
  };

  const goToPrev = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentIndex((prev) => prev - 1);
  };

  const handleTransitionEnd = () => {
    if (currentIndex === extendedContributions.length - 1) {
      // Transition from last cloned to real first
      setTimeout(() => {
        setCurrentIndex(1); // Real first index
        setIsTransitioning(false);
      }, 50);
    } else if (currentIndex === 0) {
      // Transition from first cloned to real last
      setTimeout(() => {
        setCurrentIndex(contributions.length); // Real last index
        setIsTransitioning(false);
      }, 50);
    } else {
      setIsTransitioning(false); // Normal transition end
    }
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => goToNext(),
    onSwipedRight: () => goToPrev(),
    trackMouse: true,
  });

  return (
    <section
      id="contributions"
      className="py-8 md:py-12 flex flex-col justify-center items-center bg-[#090522] p-4 md:p-8"
    >
      <h2 className="text-2xl md:text-4xl font-bold mb-4 text-center">
        <span className="text-orange-500">OUR </span>
        <span className="text-yellow-400">CONTRIBUTIONS</span>
      </h2>

      <div className="relative w-full max-w-5xl">
        {/* Left Arrow */}
        <button
          onClick={goToPrev}
          className="absolute top-1/2 -left-2 md:-left-4 transform -translate-y-1/2 bg-gray-800 text-white rounded-full w-8 h-8 md:w-10 md:h-10 flex items-center justify-center hover:bg-gray-600 z-10"
        >
          <FaArrowLeft />
        </button>

        {/* Right Arrow */}
        <button
          onClick={goToNext}
          className="absolute top-1/2 -right-2 md:-right-4 transform -translate-y-1/2 bg-gray-800 text-white rounded-full w-8 h-8 md:w-10 md:h-10 flex items-center justify-center hover:bg-gray-600 z-10"
        >
          <FaArrowRight />
        </button>

        <div {...swipeHandlers} className="overflow-hidden rounded-lg w-full">
          <div
            ref={containerRef}
            onTransitionEnd={handleTransitionEnd}
            className={`flex ${
              isTransitioning
                ? "transition-transform duration-500 ease-in-out"
                : ""
            }`}
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {extendedContributions.map((item, index) => (
              <div
                key={index}
                className="min-w-full px-2 md:px-4 bg-[#090522] select-none"
              >
                <div className="overflow-hidden rounded-md">
                  <img
                    src={item.image}
                    alt={`Contribution ${index}`}
                    className="w-full h-48 sm:h-64 md:h-80 lg:h-96 object-cover"
                  />
                </div>
                <p className="text-white text-xs md:text-sm mt-3 mb-8 md:mt-4 tracking-wider">
                  {item.info}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <ScrollToHomeButton />
    </section>
  );
};

export default Contributions;
